import lazyScreen from '../utils/lazyScreen';
const ACUserGroups = lazyScreen(() => import('../pages/user/group/ACUserGroups/index.js'), 'pages/user/group/ACUserGroups/index.js');
const ACUserGroup = lazyScreen(() => import('../pages/user/group/ACUserGroup/index.js'), 'pages/user/group/ACUserGroup/index.js');
const ACUserAccount = lazyScreen(() => import('../pages/user/account/ACUserAccount/index.js'), 'pages/user/account/ACUserAccount/index.js');
const ACUserAccounts = lazyScreen(() => import('../pages/user/account/index.js'), 'pages/user/account/index.js');
const ACUserApprovals = lazyScreen(() => import('../pages/user/approval/index.js'), 'pages/user/approval/index.js');
const ACUserSetting = lazyScreen(() => import('../pages/user/setting/ACUserSetting/index.js'), 'pages/user/setting/ACUserSetting/index.js');
const ChatWorkspace = lazyScreen(() => import('../pages/user/ChatWorkspace/index.js'), 'pages/user/ChatWorkspace/index.js');

export default [
    {
        path: '/user/ChatWorkspace',
        component: ChatWorkspace
    },
    {
        path: '/user/ACUserAccount/:code',
        component: ACUserAccount
    },
    {
        path: '/user/ACUserAccounts',
        component: ACUserAccounts
    },
    {
        path: '/user/ACUserGroups',
        component: ACUserGroups
    },
    {
        path: '/user/ACUserGroup/:code',
        component: ACUserGroup
    },
    // {
    //     path: '/user/ACUserApprovals',
    //     component: ACUserApprovals
    // },
    {
        path: '/user/ACUserSetting/:code',
        component: ACUserSetting
    }
];
